/**
 * Jisp Retailer API v1.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */


export interface Open360EntitiesRetailerApiStoreTapAndGoListItem {
    ID?: number;
    Name?: string;
    Town?: string;
    PinCode?: string;
    RandomCheckEnabled?: boolean;
    RandomCheckChance?: number;
    RandomCheckDayLimit?: number;
    /**
     * 1 = AddToCart, 2 = ShowDetails, 3 = FlickeringCards, 4 = TapTap
     */
    DefaultProductScanAction?: Open360EntitiesRetailerApiStoreTapAndGoListItem.DefaultProductScanActionEnum;
    CheckInNfcStickers?: Array<string>;
    CheckOutNfcStickers?: Array<string>;
    /**
     * 1 = TapAndGo, 2 = ClickCollectOrInStore
     */
    PaymentFlow?: Open360EntitiesRetailerApiStoreTapAndGoListItem.PaymentMethodEnum;
    PayNowEnabled?: boolean;
    CollectWithoutPincode: boolean;
    MonitorKey?: string;
    FoodMonitor?: boolean;
    HideMonitor?: boolean;
}
export namespace Open360EntitiesRetailerApiStoreTapAndGoListItem {
    export type DefaultProductScanActionEnum = 1 | 2 | 3 | 4;
    export const DefaultProductScanActionEnum = {
        NUMBER_1: 1 as DefaultProductScanActionEnum,
        NUMBER_2: 2 as DefaultProductScanActionEnum,
        NUMBER_3: 3 as DefaultProductScanActionEnum,
        NUMBER_4: 4 as DefaultProductScanActionEnum
    }
    export type PaymentMethodEnum = 1 | 2;
    export const PaymentMethodEnum = {
        NUMBER_1: 1 as PaymentMethodEnum,
        NUMBER_2: 2 as PaymentMethodEnum
    }
}



// WEBPACK FOOTER //
// ./src/app.retailer/modules/model/open360EntitiesRetailerApiStoreTapAndGoListItem.ts